interface EnvVars {
  CLIENT_ID: string;
  AUTH_HOST: string;
  HOST: string;
}

export type Env = 'acc1' | 'prod' | 'dev';

export const DATA_DOG = {
  APP_ID: '56c9be70-154f-4303-b02e-623386b63dbf',
  CLIENT_TOKEN: 'pubb873186ab90eb77658880a246e294f6f',
};

export const ENV_VARS: Record<Env, EnvVars> = {
  prod: {
    CLIENT_ID: '3plrdgtjnf5mqpe7tli60bms20',
    AUTH_HOST: 'https://ecom-auth.kronansapotek.io',
    HOST: 'https://ehandelsportalen.kronansapotek.io',
  },
  acc1: {
    CLIENT_ID: '1knggi5sijer6kfc52rio67b6r',
    AUTH_HOST: 'https://ecom-auth.acc1.kdapotek.io',
    HOST: 'https://ehandelsportalen.acc1.kdapotek.io',
  },
  dev: {
    CLIENT_ID: '6p644samuoh9n160ejvndd4jg6',
    AUTH_HOST: 'https://ecom-auth.dev.kdapotek.io',
    HOST: 'https://ehandelsportalen.dev.kdapotek.io',
  },
};
